export const Paths = {
  HOME: '/',
  APPS: '/apps',
  AGENTS: '/agents',
  FEATURED: '/featured',
  FEATURED_PAGE: '/featured/page/:page',
  FEATURED_COLLECTION: '/featured/:collectionSlug',
  LISTING_DETAILS: '/listing/:listingSlug',
  LISTING_REVIEWS: '/listing/:listingSlug/reviews',
  SEARCH_RESULTS: '/explore'
};